import React from 'react';

// App-wide safety net. Without this, a single uncaught error thrown during render
// or inside an effect (e.g. Leaflet receiving a corrupt coordinate) unmounts the
// whole React tree and the user is left staring at just the page background.
// The boundary keeps the app usable by showing a recoverable fallback instead.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && (error.message || String(error))) || "" };
  }

  componentDidCatch(error, info) {
    // Surface for debugging; also try to report so we learn about future breakages.
    try { console.error("[HamExpert] Uncaught UI error:", error, info); } catch (e) {}
    try {
      fetch("/api/client-error", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: error && (error.message || String(error)),
          stack: error && error.stack,
          componentStack: info && info.componentStack,
          url: (typeof window !== "undefined" && window.location) ? window.location.href : ""
        })
      }).catch(function () {});
    } catch (e) {}
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    var pt = typeof navigator !== "undefined" && /^pt/i.test(navigator.language || "");
    var title = pt ? "Ops! Algo travou nesta tela" : "Oops! Something broke on this screen";
    var body = pt
      ? "A aplicação encontrou um erro inesperado ao montar esta visualização. Seus dados estão salvos e seguros. Tente recarregar a página."
      : "The app hit an unexpected error while building this view. Your data is saved and safe. Please reload the page.";
    var reloadLabel = pt ? "Recarregar" : "Reload";

    return React.createElement(
      "div",
      { style: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0c1133", color: "#eef1ff", fontFamily: "'Inter',-apple-system,sans-serif", padding: 24 } },
      React.createElement(
        "div",
        { style: { maxWidth: 460, textAlign: "center", background: "#141a44", border: "1px solid #34407e", borderRadius: 16, padding: "32px 28px", boxShadow: "0 0 40px rgba(0,0,0,0.4)" } },
        React.createElement("div", { style: { fontSize: 44, marginBottom: 12 } }, "🛰️"),
        React.createElement("div", { style: { fontSize: 20, fontWeight: 800, marginBottom: 10 } }, title),
        React.createElement("div", { style: { fontSize: 14, lineHeight: 1.6, color: "#aab3e0", marginBottom: 22 } }, body),
        React.createElement(
          "button",
          {
            onClick: function () { try { window.location.reload(); } catch (e) {} },
            style: { background: "#00d4ff", color: "#04223a", border: "none", padding: "12px 28px", borderRadius: 10, fontSize: 14, fontWeight: 800, cursor: "pointer" }
          },
          reloadLabel
        ),
        this.state.message
          ? React.createElement("div", { style: { marginTop: 18, fontSize: 11, color: "#5b6699", fontFamily: "monospace", wordBreak: "break-word" } }, this.state.message)
          : null
      )
    );
  }
}
